<template
  ><v-card class="p-4">
    <!-- titre de la page + add user -->
    <v-card-title>
      Nos utilisateurs Bosco
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <!-- bouton trash à partir de 2 checkbox de cocher -->
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="red">
        <v-icon dark v-model="selected" small @click="deleteUsers(selected[0].user)">
          mdi-delete
        </v-icon>
      </v-btn>

      <!-- <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="purple darken-2">
        <v-icon dark v-model="selected" small @click.stop="editMultiple()">
          mdi-pencil
        </v-icon>
      </v-btn> -->

      <router-link :to="{ name: 'creerUtilisateurBosco' }">
        <v-btn class="mx-2" fab dark small color="indigo">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </router-link>

    </v-card-title>

    <!-- tableau + selection multiple + corbeille -->
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      hide-default-footer
      v-model="selected"
      :single-select="singleSelect"
      show-select
    >

      <!-- date de création de l'utilisateur -->
      <template v-slot:item.createdAt="{ item }">
        <span v-if="item.createdAt">{{ item.createdAt|moment}}</span>
      </template>

      <template v-slot:item.lastConnection="{ item }">
        <span v-if="item.lastConnection">{{ item.lastConnection|moment }}</span>
        <span v-else>Aucune connexion</span>

      </template>

      <!-- modification / supression utilisateur -->
      <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="{ name: 'modifierUtilisateurBosco', params: { id: item.id, user: item },}">
          <v-icon small class="mr-2">mdi-pencil</v-icon>
        </router-link>
        <v-icon small @click="deleteUser(item)">mdi-delete</v-icon>
      </template>
      <!-- Envoi initialisation de mdp -->
      <template v-slot:item.hasPassword="{ item }">
        <v-icon v-if="item.hasPassword" small color="green">mdi-checkbox-marked-circle</v-icon>
        <v-icon v-else small color="red">mdi-checkbox-blank-circle</v-icon>
      </template>
      <!-- Définition du type-->
      <template v-slot:item.type="{ item }">
            <v-chip x-small class="pa-2" color="pink" text-color="white" v-if="item.type == '0'" >Interne</v-chip>
            <v-chip x-small class="pa-2" color="blue" text-color="white" v-if="item.type == '1'" >SSO</v-chip>
      </template>
    </v-data-table>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      class="pt-5"
    ></v-pagination>
  </v-card>
</template>

<script>

//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "usersBosco",
  data() {
    return {
      confirmDelete: false,
      loading: true,
      //options: {},
      search: "",
      headers: [
        { text: "Type", value: "type" , align:"center"},
        { text: "Nom", value: "lastname", align: "start" },
        { text: "Prénom", value: "firstname", align: "start" },
        { text: "E-mail", value: "email", align: "start" },
        { text: "Rôle", value: "roles[0]", align: "start" },
        { text: "Client", value: "client.name", align: "start" },
        { text: "Droit utilisateur", value: "userRight.name", align: "start" },
        { text: "Dernière connexion", value: "lastConnection", align: "start" },
        { text: "Crée le", value: "createdAt", align: "start" },
        { text: "Mot de passe", value: "hasPassword", align: "center" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      users: [],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      deletedIndex: -1,
      singleSelect: false,
      selected: [], // Liste des utilisateurs sélectionnés dans le tableau
      dialog: false,
      userRights: [],
	usersAdmin: []
    };
  },
  filters: {
    moment: function(date) {
      return moment.parseZone(date).format("DD/MM/YYYY");
    },
  },
  methods: {
    getAllUsers() {
		this.loading = true;
		Api.query("users", {
			params: {
				pagination: false,
				roles: ["ROLE_ADMIN"] // All but Users and Super Users
			}
		}).then((users) => {
			this.users = users.data["hydra:member"];
			//this.usersAdmin = this.users.find(u => u.roles[0].includes("ROLE_ADMIN"))
			this.pagination.pagesNumber = Math.ceil(
			users.data["hydra:totalItems"] / 12
        );

        this.loading = false;
      });
    },
    deleteUser(item) {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce user ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedIndex = this.users.indexOf(item);
          Api.delete("users/" + item.id).then(() => {
            this.users.splice(this.deletedIndex, 1),
              Swal.fire(
                "Supprimé !",
                "Votre utilisateur a été supprimé",
                "success"
              ),
              this.selected = [];
              this.getAllUsers();
          });
        }
      });
    },
    deleteUsers() {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce user ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedItems = this.selected
          for(var i=0; i < selectedItems.length; i++){
            //let deletedIndex = this.users.findIndex(el => el.user === selectedItems[i]);
            Api.delete("users/" + selectedItems[i].id).then(() => { //TODO : appeler la fonction de callback. cf https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Promise/all
            //this.users.splice(deletedIndex, 1);
              Swal.fire(
                "Supprimé !",
                "Votre utilisateur a été supprimé",
                "success"
              ),
              this.getAllUsers();
            });
          }
        }
      });
    },
  },

  mounted() {
    this.getAllUsers();
  },
};
</script>
